module.exports = __webpack_public_path__ + "img/service.1938706.png";